var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Registry from '@sxmp/registry';
var ENABLE_REGISTER_CAPTCHA_API = 2;
var detectorManagerPlaceholder = {
    report: function () { return Promise.resolve({}); },
    stop: function () {
        // Stop does not do anything in the placeholder
    },
    update: function () {
        // Update does not do anything in the placeholder
    },
};
var detectorTagPlaceholder = {
    start: function () { return detectorManagerPlaceholder; },
};
// TODO: WEBCA-1943 make retryLimit & retryDelay configurable
export function loadDetectorScript(src, retryCount, retryLimit, retryDelay) {
    if (retryCount === void 0) { retryCount = 0; }
    if (retryLimit === void 0) { retryLimit = 3; }
    if (retryDelay === void 0) { retryDelay = 1000; }
    return new Promise(function (resolve, reject) {
        var detectorScriptElement = document.createElement('script');
        var currentRetryCount = retryCount;
        var detectorError = 'Failed to load detector script. retry count: ';
        // HUMAN: We have purposely omitted the async attribute from the initial script tag to ensure that it loads as early as possible to capture more signals from the browser and improves bot detection efficacy
        if (currentRetryCount > 0) {
            detectorScriptElement.async = true;
        }
        detectorScriptElement.onerror = function (error) {
            var _a;
            detectorScriptElement.remove();
            if (currentRetryCount < retryLimit) {
                currentRetryCount++;
                setTimeout(function () {
                    loadDetectorScript(src, currentRetryCount);
                }, retryDelay);
            }
            else {
                (_a = Registry.logger) === null || _a === void 0 ? void 0 : _a.error(error);
            }
            reject(error);
        };
        detectorScriptElement.onload = function () {
            var _a;
            if (window.$$$) {
                resolve(window.$$$);
            }
            else {
                (_a = detectorScriptElement.onerror) === null || _a === void 0 ? void 0 : _a.call(detectorScriptElement, new ErrorEvent("".concat(detectorError, " ").concat(currentRetryCount)));
            }
        };
        document.head.appendChild(detectorScriptElement);
        detectorScriptElement.src = src;
    });
}
function hsOptionsMapper(options) {
    if (options === void 0) { options = {}; }
    return Object.assign({
        ui: options.listenerId || null,
        ap: options.appId || null,
        ck: options.cookieId || null,
        dv: options.deviceId || null,
        si: options.siteId || null,
    }, options);
}
var Detector = /** @class */ (function () {
    function Detector(config, detectorScriptLoader) {
        if (detectorScriptLoader === void 0) { detectorScriptLoader = loadDetectorScript; }
        var _this = this;
        this.url = function (listenerId) {
            return "".concat(_this.config.url, "?dt=").concat(_this.config.tagId, "&ci=").concat(_this.config.clientId, "&spa=1&pd=acc&mo=2&di=").concat(_this.config.deviceId, "&si=").concat(_this.config.siteId, "&ui=").concat(listenerId || null, "&captcha=").concat(ENABLE_REGISTER_CAPTCHA_API);
        };
        this.init = function (listenerId) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.detectorScriptLoader(this.url(listenerId))];
                    case 1:
                        _a.detectorTag = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.start = function (params) {
            if (params === void 0) { params = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(this.detectorTag === detectorTagPlaceholder)) return [3 /*break*/, 2];
                            _a = this;
                            return [4 /*yield*/, this.detectorScriptLoader(this.url(params.listenerId))];
                        case 1:
                            _a.detectorTag = _b.sent();
                            _b.label = 2;
                        case 2:
                            this.detectorManager = this.detectorTag.start(hsOptionsMapper(params));
                            return [2 /*return*/];
                    }
                });
            });
        };
        this.stop = function () {
            _this.detectorManager.stop();
        };
        this.update = function (options) {
            _this.detectorManager.update(hsOptionsMapper(options));
        };
        this.report = function (options) {
            return _this.detectorManager.report(options);
        };
        this.config = config;
        this.detectorTag = detectorTagPlaceholder;
        this.detectorManager = detectorManagerPlaceholder;
        this.detectorScriptLoader = detectorScriptLoader;
    }
    return Detector;
}());
export { Detector };
